import { content } from '../../data';

import './About.css';

const About = ({ lang }) => {
  const t = content[lang].about;

  return (
    <section id="about" className="about-section">
      <div className="about-grid">
        <div className="about-col-left">{t.title}</div>
        <div className="about-col-right">
          <p className="about-text">
            {t.mainText}
          </p>
          <div className="about-details">
            <div>
              <h3>{t.servicesTitle}</h3>
              <ul>
                {t.services.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            </div>
            <div>
              <h3>{t.longTermPartnershipsTitle}</h3>
              <ul>
                {t.longTermPartnerships.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;